/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Entity
 */
export type VerifySMSCodeRequestEntity = typeof VerifySMSCodeRequestEntity[keyof typeof VerifySMSCodeRequestEntity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifySMSCodeRequestEntity = {
  User: 'User',
} as const;
